export const START_NEW_CHAT = "START NEW CHAT";
export const AI_AGENTS = [{ label: "Gemini", value: "Gemini" }];

export const RATIO_BUTTON_RATIOS = ["100% 0%", "80% 20%", "50% 50%", "0% 100%"];

export const FULL_CHAT_INDEX = 0; // 1st button
export const PAGE_SPLIT_8020_INDEX = 1; // 2nd button
export const PAGE_SPLIT_5050_INDEX = 2; // 3rd button
export const FULL_PRODUCT_INDEX = 3; // 4th button
